export const colors = {
  white: '#FFFFFF',
  black: '#282828',
  blue50: '#F5FAFD',
  blue100: '#EAF2F6',
  grey100: '#dde3eb',
  grey400: '#718091',
  grey800: '#373c40',
};
